var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":require('../../assets/icons/soundcloud_icon.png'),"alt":"Soundcloud Icon","width":_vm.width,"height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }